"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var validation_exports = {};
__export(validation_exports, {
  ANDROID_HAPTICS: () => ANDROID_HAPTICS,
  IMPACT_STYLES: () => IMPACT_STYLES,
  NOTIFICATION_TYPES: () => NOTIFICATION_TYPES,
  assertAndroidHaptic: () => assertAndroidHaptic,
  assertImpact: () => assertImpact,
  assertNotification: () => assertNotification
});
module.exports = __toCommonJS(validation_exports);
var IMPACT_STYLES = [
  "light",
  "medium",
  "heavy",
  "soft",
  "rigid"
];
var NOTIFICATION_TYPES = [
  "success",
  "warning",
  "error"
];
var ANDROID_HAPTICS = [
  "clock-tick",
  "confirm",
  "context-click",
  "drag-start",
  "gesture-end",
  "gesture-start",
  "keyboard-press",
  "keyboard-release",
  "keyboard-tap",
  "long-press",
  "no-haptics",
  "reject",
  "segment-frequent-tick",
  "segment-tick",
  "text-handle-move",
  "toggle-off",
  "toggle-on",
  "virtual-key",
  "virtual-key-release"
];
function assertAndroidHaptic(type) {
  if (!ANDROID_HAPTICS.includes(type)) {
    throw new TypeError(`One.Haptics.performAndroidHaptics: unknown type ${JSON.stringify(type)}. Expected one of: ${ANDROID_HAPTICS.join(", ")}.`);
  }
}
function assertImpact(style) {
  if (!IMPACT_STYLES.includes(style)) {
    throw new TypeError(`One.Haptics.impact: unknown style ${JSON.stringify(style)}. Expected one of: ${IMPACT_STYLES.join(", ")}.`);
  }
}
function assertNotification(type) {
  if (!NOTIFICATION_TYPES.includes(type)) {
    throw new TypeError(`One.Haptics.notification: unknown type ${JSON.stringify(type)}. Expected one of: ${NOTIFICATION_TYPES.join(", ")}.`);
  }
}
//# sourceMappingURL=validation.js.map
